(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name user.controller:ConfirmationCtrl
   *
   * @description
   *
   */
  angular
  .module('neo.authentication')
  .controller('PasswordTokenCtrl', PasswordTokenCtrl);

  function PasswordTokenCtrl($state, $stateParams, $mdToast, $filter, passwordTokenConfirmation) {
    var vm = this;
    vm.ctrlName = 'PasswordTokenCtrl';

    if (passwordTokenConfirmation === 'valid') {
      $state.go('authentication.newPassword', {token: $stateParams.token});
    } else if (passwordTokenConfirmation === 'invalid') {
      $mdToast.show(
        $mdToast.simple()
        .textContent($filter('translate')('TOKEN_NOT_FOUND'))
        .position('bottom left')
        .hideDelay(3000)
      );
      $state.go('authentication.login');
    }
  }
}());
